import timg1 from '../images/team/doctor-profile.png'
// import timg2 from '../images/team/employee1.jpeg'
// import timg3 from '../images/team/employee2.jpeg'
// import timg4 from '../images/team/employee3.jpeg'
// import timg5 from '../images/team/employee4.jpeg'
// import timg6 from '../images/team/employee5.jpeg'
const Teams = [
   {
      id: '1',
      tImg: timg1,
      name: 'Dr. Tri Tran',
      title: 'D.M.D',
   },
   // {
   //    id: '2',
   //    tImg: timg2,
   //    name: 'Allison Katrina',
   //    title: 'dental assistant',
   // },
   // {
   //    id: '3',
   //    tImg: timg3,
   //    name: 'Raquel Riley',
   //    title: 'front dest assistant',
   // },
   // {
   //    id: '4',
   //    tImg: timg4,
   //    name: 'Anna Watson',
   //    title: 'dental assistant',
   // },
   // {
   //    id: '5',
   //    tImg: timg5,
   //    name: 'Andrew Silva',
   //    title: 'dental assistant',
   // },
   // {
   //    id: '6',
   //    tImg: timg6,
   //    name: 'David Miller',
   //    title: 'hygenist',
   // },
]

export default Teams;